import { Checkbox, TableCell, TableRow } from "@mui/material";
import React from "react";
import { useRecipesPage } from "./useRecipesPage";

export const OrgHeaderRow = ({ hasScoringSystem }: { hasScoringSystem: boolean }) => {
  const { isBulkDeleteRecipesEnabled, selectedRecipeIds, visibleRecipeIds, toggleSelectAllVisibleRecipes } = useRecipesPage();
  const allVisibleSelected = visibleRecipeIds.length > 0 && visibleRecipeIds.every(id => selectedRecipeIds.has(id));
  const someVisibleSelected = visibleRecipeIds.some(id => selectedRecipeIds.has(id));

  return (
    <TableRow>
      {isBulkDeleteRecipesEnabled && (
        <TableCell padding="checkbox">
          <Checkbox
            onClick={toggleSelectAllVisibleRecipes}
            checked={allVisibleSelected}
            indeterminate={someVisibleSelected && !allVisibleSelected}
            inputProps={{ "aria-label": "Select all recipes" }}
          />
        </TableCell>
      )}
      <TableCell sx={{ width: 150 }}>Shared</TableCell>
      <TableCell>Name</TableCell>
      <TableCell>Created By</TableCell>
      <TableCell>Meal Types</TableCell>
      <TableCell>Yields</TableCell>
      {hasScoringSystem && <TableCell>Score</TableCell>}
      <TableCell>Date Created</TableCell>
      <TableCell>Last Updated</TableCell>
      <TableCell padding="checkbox">Actions</TableCell>
    </TableRow>
  );
};

export const OrgGroupHeaderRow = ({ hasScoringSystem }: { hasScoringSystem: boolean }) => (
  <TableRow>
    <TableCell sx={{ width: 150 }}>Shared</TableCell>
    <TableCell>Name</TableCell>
    <TableCell>Org Group</TableCell>
    <TableCell>Managed By</TableCell>
    <TableCell>Meal Types</TableCell>
    <TableCell>Yields</TableCell>
    {hasScoringSystem && <TableCell>Score</TableCell>}
    <TableCell># of Duplications</TableCell>
    <TableCell padding="checkbox">Actions</TableCell>
  </TableRow>
);

export const NotemealHeaderRow = () => (
  <TableRow>
    <TableCell sx={{ width: 150 }}>Shared</TableCell>
    <TableCell>Name</TableCell>
    <TableCell>Created By</TableCell>
    <TableCell>Meal Types</TableCell>
    <TableCell>Yields</TableCell>
    <TableCell>Date Added</TableCell>
    <TableCell padding="checkbox">Actions</TableCell>
  </TableRow>
);
